define('modules/player/player_model',['backbone',
  '_',
  'session'
], function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    url: function () {
      return session.get('apiUrl') + 'players/' + this.get('id');
    }
  });

  return Model;
});

